module.exports = __webpack_public_path__ + "static/enLogo-5d56e6ab1249132202ebfb3de9dc2282.png";